import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class StoreStateService {
  private storeIdKey = 'selectedStoreId';
  private storeFlagKey = 'isKisnaStoreAdmin';
  private storeIsCocoKey = 'isCoco'

  private _storeIdSubject = new BehaviorSubject<number | null>(null);
  private _storeFlagSubject = new BehaviorSubject<boolean | null>(null);
  private _storeCocoSubject = new BehaviorSubject<boolean | null>(null);


  public storeId$ = this._storeIdSubject.asObservable();
  public storeFlag$ = this._storeFlagSubject.asObservable();
  public storeCoco$ = this._storeCocoSubject.asObservable();


constructor() {
  const storedId = localStorage.getItem(this.storeIdKey);
  const storedFlag = localStorage.getItem(this.storeFlagKey);
  const storedIsCoco = localStorage.getItem(this.storeIsCocoKey);

  this._storeIdSubject.next(storedId ? +storedId : null);
  this._storeFlagSubject.next(storedFlag !== null ? storedFlag === 'true' : null);
  this._storeCocoSubject.next(storedIsCoco !== null ? storedIsCoco === 'true' : null);
}


  setStoreId(id: number) {
    localStorage.setItem(this.storeIdKey, `${id}`);
    this._storeIdSubject.next(id);
  }

  setStoreFlag(flag: boolean) {
    localStorage.setItem(this.storeFlagKey, `${flag}`);
    this._storeFlagSubject.next(flag);
  }

  setStoreisCoco(isCoco: boolean) {
    localStorage.setItem(this.storeIsCocoKey, `${isCoco}`);
    this._storeCocoSubject.next(isCoco);
  }

  setStoreIdAndFlag(id: number, flag: boolean, isCoco: boolean) {
    this.setStoreId(id);
    this.setStoreFlag(flag);
    this.setStoreisCoco(isCoco);

  }

  getStoreId(): number | null {
    return this._storeIdSubject.getValue();
  }

  getStoreFlag(): boolean | null {
    return this._storeFlagSubject.getValue();
  }

  getStoreIsCoco(): boolean | null {
    return this._storeCocoSubject.getValue();
  }

  clearStore() {
    localStorage.removeItem(this.storeIdKey);
    localStorage.removeItem(this.storeFlagKey);
    localStorage.removeItem(this.storeIsCocoKey);

    this._storeIdSubject.next(null);
    this._storeFlagSubject.next(null);
    this._storeCocoSubject.next(null);
  }
}
